import React from 'react';

import { Color } from '../../types/theme';
import { hexToRGB } from '../../utils/hex-to-rgb';
import { useTimer } from '../../hooks/use-game-timer';
import { OverlayContext } from '../../contexts/overlay';
import { GameDocumentContext } from '../../contexts/game-document';

export const TimerProgressBar = () => {
  const [gameDocument] = React.useContext(GameDocumentContext);
  const [overlay] = React.useContext(OverlayContext);

  const theme: Color[] = gameDocument?.theme?.colors ?? [];

  const { timer, seconds } = useTimer(overlay.timerAssId ?? '');

  const overlayTimerBg = React.useMemo(() => {
    const infoColor = theme?.find((x) => x.type === 'Info')?.color;
    if (infoColor) return hexToRGB(infoColor).replace('1)', '0.85)');
    return 'rgba(13,197,232,0.85)';
  }, [theme]);

  const percentage = React.useMemo(() => {
    const duration = timer?.durationMs ?? 0;
    if (duration <= 0) return 0;

    const ratio = (seconds * 1000) / duration;
    const progress = timer?.mode === 'down' ? 1 - ratio : ratio;

    return Math.min(100, Math.max(0, progress * 100));
  }, [seconds, timer?.durationMs, timer?.mode]);

  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: `linear-gradient(90deg, ${overlayTimerBg} ${percentage}%, transparent ${percentage}%)`
      }}
    />
  );
};
